import React from 'react';
import VaccineCatalogManager from '../../head-doctor/vaccines/VaccineCatalogManager';
import { MAJOR_COPY } from '../majorCopy';

export default function MajorVaccinesPage() {
  return <VaccineCatalogManager copy={MAJOR_COPY.VACCINE_CATALOG} />;
}
